// Espelho em TypeScript de `src/styles/_tokens.scss` (usado por antd e pelos
// gráficos). Mantenha os dois arquivos em sincronia.
export const colors = {
  primary: "#004aad",
  primaryHover: "#002c6a",
  primarySoft: "#e6f0ff",
  accent: "#fa6101",
  navy: "#0b1f3a",
  text: "#13293d",
  textSecondary: "#5a646e",
  textMuted: "#8a95a3",
  borderStrong: "#d6dde8",
  border: "#e3e8f0",
  track: "#eef1f6",
  bg: "#f3f5f9",
  surface: "#ffffff",
  surfaceSubtle: "#f5f7fb",
  success: "#0f7a4a",
  successBg: "#e3f6ec",
  warning: "#a34000",
  warningBg: "#fff4e5",
  danger: "#b3261e",
  dangerBg: "#fdecea",
  info: "#1d3f73",
  infoBg: "#eef4ff",
} as const;

// Ordem fixa das séries nos gráficos (Manual 01 — Dados e gráficos).
export const chartColors = {
  series: ["#004aad", "#fa6101", "#00838f", "#7cc4ff"],
  other: "#8a95a3",
  bots: "#c3ccd8",
} as const;

export const fonts = {
  display: '"Bricolage Grotesque", "Plus Jakarta Sans", sans-serif',
  body: '"Plus Jakarta Sans", system-ui, -apple-system, "Segoe UI", sans-serif',
} as const;
